export const required = value => value ? undefined : 'Required';

export const minLength = min => value =>
  value && value.length < min ? `Must be at least ${min} characters` : undefined;

export const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;

export const matchPwd = (value, allValues) => {
  const { password } = allValues;
  return password && value && password !== value ? 'Must match password' : undefined;
}

export const matches = (regex, format) => value =>
  value && value.match(regex) ? undefined : `Must match ${format}`;



// WEBPACK FOOTER //
// ./src/core/utils/validations.js